export class CustomHeaders{
    public static readonly skipInterceptor = 'skip-Interceptor'
}